import { IconComponent } from './types';

const PinIcon: IconComponent<{ color?: string }> = ({ color, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={16}
    viewBox="0 0 11 16"
    fill="none"
    {...props}
  >
    <path
      fill={color || 'currentColor'}
      fillRule="evenodd"
      d="M5.25.5A5.246 5.246 0 0 0 0 5.75c0 3.938 5.25 9.75 5.25 9.75s5.25-5.813 5.25-9.75A5.246 5.246 0 0 0 5.25.5Zm.05 7.65a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default PinIcon;
